<template>
  <div class="c-filter-dropdown">
    <button
      class="c-filter-dropdown__button"
      :class="{ 'c-filter-dropdown__button--active': dropdownOpen }"
      @click="$emit('toggle-dropdown')"
    >
      <div class="c-filter-dropdown__button-tag">
        {{ this.translate.select }} {{ label }}
      </div>
      <div class="c-filter-dropdown__button-text">{{ buttonText }}</div>
      <div
        aria-hidden="true"
        class="c-icon c-icon--xs c-filter-dropdown__toggle-icon"
      >
        <svg v-if="!dropdownOpen"><use :xlink:href="`#icon-plus`"></use></svg>
        <svg v-else><use :xlink:href="`#icon-minus`"></use></svg>
      </div>
    </button>
    <slot />
  </div>
</template>

<script>
export default {
  name: "VFilterDropdown",
  props: {
    label: {
      type: String,
      required: false,
    },
    buttonText: {
      type: String,
      required: true,
    },
    dropdownOpen: {
      type: Boolean,
      required: true,
    },
    translate: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
